<template>
	<c-dialog ref="dialog" width="650" :title="title" height="510" @resolve="editHandle">
        <div class="feedback-display">
            <c-title>反馈内容</c-title>
            <c-detail>
                <c-detail-item label="反馈用户">
                    {{feedbackData.create_user_realname}}
                    <c-state dict="userTypeDic" tag :value="feedbackData.suggestion_user_type"></c-state>
                </c-detail-item>
                <c-detail-item label="反馈类型">
                    <c-state dict="suggestionTypcDic" tag :value="feedbackData.suggestion_type"></c-state>
                </c-detail-item>
                <c-detail-item label="反馈内容">
                    {{feedbackData.feedback_content}}
                </c-detail-item>
                <c-detail-item label="反馈图片" v-if="feedbackData.feedback_images">
                    <c-file-list :value="feedbackData.feedback_images" readonly></c-file-list>
                </c-detail-item>
            </c-detail>
        </div>
        <c-title>平台回复</c-title>
		<c-form ref="form" vertical unit-width="100%" style="margin-top: -50px;">
            <c-form-item>
                <c-input type="textarea" name="reply_content" maxlength="500"></c-input>
            </c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	data() {
		return {
            feedbackData: {},
            title: '平台处理',
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
            this.feedbackData = data;
            this.$refs.form.clear();
            this.$refs.dialog.open();
        },

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
                url: '/complaint/suggestion/handle',
				rule: {
                    reply_content: '请输入平台回复内容'
				},
				dataFormatter: data => {
                    data.id = this.feedbackData.id;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.feedback-display {
    margin-bottom -10px
    border-bottom 0px solid #e8e8e8
}
</style>